import { useState, useEffect } from 'react';
import { Platform } from 'react-native';
import * as ScreenOrientation from 'expo-screen-orientation';
import { initialWindowMetrics } from 'react-native-safe-area-context';
import { Observable } from '../../Data/Observable/Observable';
const orientation = new Observable(ScreenOrientation.Orientation.PORTRAIT_UP);
const isLandscape = new Observable(false);
const offset = new Observable({
    top: (initialWindowMetrics === null || initialWindowMetrics === void 0 ? void 0 : initialWindowMetrics.insets.top) || 0,
    bottom: (initialWindowMetrics === null || initialWindowMetrics === void 0 ? void 0 : initialWindowMetrics.insets.bottom) || 0,
    right: (initialWindowMetrics === null || initialWindowMetrics === void 0 ? void 0 : initialWindowMetrics.insets.right) || 0,
    left: (initialWindowMetrics === null || initialWindowMetrics === void 0 ? void 0 : initialWindowMetrics.insets.left) || 0
});
if (Platform.OS === 'web') {
    function getIsMobileDevice() {
        return navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i);
    }
    const landscapeOrientationListener = window.matchMedia('(orientation: landscape)');
    isLandscape.next(landscapeOrientationListener.matches && !!getIsMobileDevice());
    landscapeOrientationListener.addEventListener('change', e => isLandscape.next(e.matches && !!getIsMobileDevice()));
}
else {
    function handleOrientation(newOrientation) {
        orientation.next(newOrientation);
        isLandscape.next(newOrientation === ScreenOrientation.Orientation.LANDSCAPE_LEFT || newOrientation === ScreenOrientation.Orientation.LANDSCAPE_RIGHT);
    }
    ScreenOrientation.unlockAsync();
    ScreenOrientation.getOrientationAsync().then(orientation => handleOrientation(orientation));
    ScreenOrientation.addOrientationChangeListener(event => handleOrientation(event.orientationInfo.orientation));
}
export function updateOffset(update) {
    return offset.update(update);
}
export function getIsLandscape() {
    return isLandscape;
}
export function getScreenOrientation() {
    return orientation;
}
export function useScreenOrientation() {
    const [orientationValue, setOrientation] = useState(orientation.value);
    const [isLandscapeValue, setIsLandscape] = useState(isLandscape.value);
    const [offsetValue, setOffset] = useState(offset.value);
    useEffect(() => {
        const orientationSubscription = orientation.subscribe(setOrientation);
        const landscapeSubscription = isLandscape.subscribe(setIsLandscape);
        const offsetSubscription = offset.subscribe(setOffset);
        return () => {
            orientationSubscription.unsubscribe();
            landscapeSubscription.unsubscribe();
            offsetSubscription.unsubscribe();
        };
    }, []);
    return { orientation: orientationValue, isLandscape: isLandscapeValue, offset: offsetValue };
}
export function getScreenOffset() {
    return offset;
}
